import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';

export const fetchBalance = createAsyncThunk('wallet/fetchBalance', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/wallet/balance');
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Error getting balance');
  }
});

export const fetchTransactions = createAsyncThunk('wallet/fetchTransactions', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/wallet/transactions');
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Error getting transactions');
  }
});

export const fetchCustodialInfo = createAsyncThunk('wallet/fetchCustodialInfo', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/wallet/custodial-info');
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Error getting custodial info');
  }
});

export const fetchAllBalances = createAsyncThunk('wallet/fetchAllBalances', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/wallet/all-balances');
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Error getting balances');
  }
});

const walletSlice = createSlice({
  name: 'wallet',
  initialState: {
    balance: null,
    allBalances: null,
    custodialInfo: null,
    transactions: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBalance.pending, (state) => { state.loading = true; })
      .addCase(fetchBalance.fulfilled, (state, action) => { state.loading = false; state.balance = action.payload; })
      .addCase(fetchBalance.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(fetchTransactions.pending, (state) => { state.loading = true; })
      .addCase(fetchTransactions.fulfilled, (state, action) => { state.loading = false; state.transactions = action.payload; })
      .addCase(fetchTransactions.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(fetchCustodialInfo.fulfilled, (state, action) => { state.custodialInfo = action.payload; })
      .addCase(fetchAllBalances.fulfilled, (state, action) => { state.allBalances = action.payload; })
  }
});

export default walletSlice.reducer;
